var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPrescription = function SvgIconPrescription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35271 4.40727C5.89858 4.8614 5.16684 4.86594 4.71831 4.41742C4.26979 3.9689 4.27434 3.23716 4.72847 2.78303C5.18259 2.3289 5.91434 2.32435 6.36286 2.77287C6.81138 3.2214 6.80684 3.95314 6.35271 4.40727ZM5.81129 3.86586C5.65992 4.01723 5.416 4.01875 5.2665 3.86924C5.11699 3.71973 5.1185 3.47582 5.26988 3.32444C5.42126 3.17306 5.66517 3.17155 5.81468 3.32106C5.96419 3.47056 5.96267 3.71448 5.81129 3.86586Z",
    fill: "#8015D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18852 1.4058C5.69344 -0.0892717 3.2543 -0.0741218 1.74053 1.43964C0.226771 2.9534 0.211621 5.39255 1.7067 6.88762L8.47438 13.6553C9.96945 15.1504 12.4086 15.1352 13.9224 13.6215C15.4361 12.1077 15.4513 9.66856 13.9562 8.17348L7.18852 1.4058ZM13.1339 8.99576L10.2915 6.15333L6.45422 9.99061L9.29665 12.833C10.3432 13.8796 12.0506 13.869 13.1102 12.8093C14.1699 11.7497 14.1805 10.0423 13.1339 8.99576ZM6.36624 2.22808L9.47938 5.34121L5.6421 9.17849L2.52897 6.06535C1.48242 5.0188 1.49302 3.3114 2.55266 2.25176C3.61229 1.19213 5.31969 1.18152 6.36624 2.22808Z",
    fill: "#8015D0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPrescription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-prescription.1e2a754495d2ee8448660b367a0af659.svg";